var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTemperatureDarkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 25,
    viewBox: "0 0 11 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.52919 3.4504V8.75212H3.86066V3.42389C3.86949 2.69933 4.46152 2.1073 5.19492 2.1073C5.92833 2.1073 6.52035 2.69049 6.52919 3.42389V3.4504ZM6.21109 8.65493V3.5476V3.43273C6.20225 2.88489 5.74277 2.43424 5.19492 2.43424C4.64708 2.43424 4.1876 2.88489 4.17876 3.43273V3.52993V8.66376H6.21109V8.65493Z",
    fill: "#00609B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.19514 24.6045C2.36756 24.6045 0.0613098 22.2983 0.0613098 19.4707C0.0613098 17.8448 0.847732 16.3073 2.13782 15.3442V3.37996C2.13782 1.69224 3.50743 0.322632 5.19514 0.322632C6.88286 0.322632 8.25247 1.69224 8.25247 3.37996V15.3442C9.54255 16.3073 10.329 17.8448 10.329 19.4707C10.329 22.3071 8.03156 24.6045 5.19514 24.6045ZM5.19514 23.7474C7.55441 23.7474 9.47186 21.8299 9.47186 19.4707C9.47186 17.9509 8.67661 16.5724 7.39536 15.8037V3.37996C7.39536 2.1694 6.4057 1.17974 5.19514 1.17974C3.98458 1.17974 2.99493 2.1694 2.99493 3.37996V15.8037C1.71368 16.5724 0.918421 17.9509 0.918421 19.4707C0.927258 21.8299 2.84471 23.7474 5.19514 23.7474Z",
    fill: "#00609B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33914 13.8948H7.39517V14.4868H9.33914V13.8948Z",
    fill: "#00609B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33938 12.1805H8.49994V12.7726H9.33938V12.1805Z",
    fill: "#00609B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33914 10.4663H7.39517V11.0583H9.33914V10.4663Z",
    fill: "#00609B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33938 8.74341H8.49994V9.33543H9.33938V8.74341Z",
    fill: "#00609B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33914 7.02917H7.39517V7.6212H9.33914V7.02917Z",
    fill: "#00609B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33938 5.31494H8.49994V5.90697H9.33938V5.31494Z",
    fill: "#00609B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33914 3.60071H7.39517V4.19273H9.33914V3.60071Z",
    fill: "#00609B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60554 19.4706C8.60554 21.3527 7.07688 22.8813 5.19477 22.8813C3.31266 22.8813 1.784 21.3527 1.784 19.4706C1.784 18.0568 2.64111 16.855 3.8605 16.3337V8.74341H6.52904V16.3337C7.74843 16.855 8.60554 18.0656 8.60554 19.4706ZM3.40986 18.0921C2.97688 18.0921 2.63227 18.6046 2.63227 19.2231C2.63227 19.8505 2.97688 20.3542 3.40986 20.3542C3.84283 20.3542 4.18744 19.8417 4.18744 19.2231C4.18744 18.5958 3.84283 18.0921 3.40986 18.0921ZM4.3465 16.2453L4.68227 16.1747V8.74341H4.3465V16.2453Z",
    fill: "#00609B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.68236 3.79516C4.67353 3.7068 4.60284 3.63611 4.51448 3.63611C4.42611 3.63611 4.35542 3.7068 4.34659 3.79516V8.74343H4.68236V3.79516Z",
    fill: "#00609B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureDarkIcon);
export default __webpack_public_path__ + "static/media/TemperatureDarkIcon.36ff1c7f657344bfd969d5e67813a96c.svg";
export { ForwardRef as ReactComponent };